import React from 'react';
import TypedList from './TypedList';

const OPTIONS = [
  { value: 'cvl-client-owned', label: 'Cash Value Life — owned by Client or Co-Client' },
  { value: 'cvl-trust-other', label: 'Cash Value Life — owned by Trust or Other Person/Entity' },
  { value: 'non-cash-value-life', label: 'Non-Cash Value Life Policies — All Owners' },
  { value: 'other', label: 'Other Insurance Policies' },
];

export default function InsurancePolicyStep({ formData, updateFormData }) {
  return (
    <div data-testid="insurance-policy-step">
      <h2 className="text-2xl font-bold text-[#0f172a] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Insurance Policy
      </h2>
      <p className="text-sm text-[#64748b] mb-6">Add each policy — cash value life, term life, disability, LTC, etc.</p>
      <TypedList
        title="Policies"
        items={formData.policies}
        onChange={(v) => updateFormData({ ...formData, policies: v })}
        typeOptions={OPTIONS}
        amountLabel="Coverage / Cash Value"
        itemLabel="Policy"
        testIdPrefix="insurance-policy"
      />
    </div>
  );
}
